@if ((actionParams && actionResults)) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>Parameters</mat-panel-title>
      </ng-container>
      <ng-container body>
        <form [formGroup]="actionParams">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label">Name</label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: {controlName: 'name', form: actionParams}">
            </ng-container>
            <input class="control-input" activeform [activeForm]="actionParams" formControlName="name" placeholder="Enter a name" />
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label">Description</label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: { controlName: 'description', form: actionParams}">
            </ng-container>
            <input class="control-input"  activeform [activeForm]="actionParams" formControlName="description" placeholder="Enter description" />
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label">Input Variable</label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: {controlName: 'variable', form: actionParams}">
            </ng-container>
            <input class="control-input"  activeform [activeForm]="actionParams" formControlName="variable" placeholder="E.g [[variable_name]]" />
          </div>
          <div class="control-div checkbox-field no-margin">
            <mat-checkbox class="checkbox-icon" [formControlName]="'isCaseSensitive'" id="isCaseSensitive">
              Case Sensitive Matching
            </mat-checkbox>
          </div>
        </form>
      </ng-container>
    </clickatell-expansion-panel>
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>Logic</mat-panel-title>
      </ng-container>
      <ng-container body [formGroup]="actionResults">
        <div formArrayName="options">
          @if (CollapseExpand == false ) {
            <div>
              <button class="extension-btn" mat-button (click)="ExpandCollapseAll()">Expand All</button>
            </div>
          } @else {
            <button class="extension-btn" mat-button (click)="ExpandCollapseAll()">Collapse All</button>
          }
          <div cdkDropList (cdkDropListDropped)="drop($event)">
            <mat-accordion class="result-logic-list"
              [multi]="true"
              #accordion="matAccordion">
              @for (opt of  actionResults?.get('options')['controls']; track opt; let i = $index) {
                <div [formGroupName]="i" class="result-logic-item">
                  <mat-expansion-panel class="expansion-panel" [expanded]="true" cdkDrag>
                    <mat-expansion-panel-header class ="expansion-panel-header case-header">
                      <ng-container class="expansion-header">
                        <div class="panel-info" >
                          @if (opt.value['title'] ) {
                            <div class="title-text">{{ opt.value['title'] }}</div>
                          } @else {
                            <span class="title-text-before">[Value]</span>
                          }
                        </div>
                        <div class="title-btns-block">
                          <button class="move-btn" cdkDragHandle ></button>
                          <button class="remove-btn" (click)="remove(i)"></button>
                        </div>
                      </ng-container>
                    </mat-expansion-panel-header>
                    <div class="control-div case-div">
                      <div class="control-label-container case-label">
                        <label class="control-label">Value</label>
                        <ng-container
                          *ngTemplateOutlet="validators; context: {controlName: 'title', form: opt}">
                        </ng-container>
                        <input class="control-input" activeform [activeForm]="opt" id="titles" [placeholder]="'Enter a value'" [formControlName]="'title'"/>
                      </div>
                    </div>
                    <ng-container class="point-to" *ngTemplateOutlet="next; context: {controlName: 'step', form: opt}"></ng-container>
                  </mat-expansion-panel>
                </div>
              }
            </mat-accordion>
          </div>
        </div>
        <mat-accordion class="result-logic-list"
          [multi]="true"
          #Accord="matAccordion">
          <div class="other-logic-item">
            <mat-expansion-panel class="expansion-panel" expanded="true">
              <mat-expansion-panel-header class ="expansion-panel-header">
                <div class="panel-info">
                  <div class="control-label-container">
                    <label class="title-text">Other</label>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <ng-container class="point-to" *ngTemplateOutlet="next; context: {controlName: 'other', form: actionResults}"></ng-container>
            </mat-expansion-panel>
          </div>
        </mat-accordion>
        <div class="result-button">
          <button (click)="addCase()" [disabled]="!canEdit">
            Add New Result
          </button>
        </div>
      </ng-container>
    </clickatell-expansion-panel>
  </div>
}

<ng-template #validators let-controlName="controlName" let-form=form>
  @if (form.controls[controlName]; as control) {
    @if (control.invalid && (control.dirty || control.touched)) {
      <div class="validationField">
        @for (error of control.errors | keyvalue; track error) {
          <div>
            <span class="fa fa-exclamation-circle"></span>
            <span [id]="'validationField-' + controlName">
              {{error.value}}
            </span>
          </div>
        }
      </div>
    }
  }
</ng-template>

<ng-template #next let-controlName="controlName" let-form=form>
  <div class="point-to-container">
    <label class="control-label">Point To</label>
    <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
  </div>
  @if (nodeFlowDetails) {
    <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
      [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
      [name]="controlName"
    [form]="form"></next-selector>
  }
</ng-template>

